<div class="container">
  <div class="container header-container">
    <div class="header-title-container">
      <p>
        <adp-label labelKey="Account_Profile_Heading"></adp-label>
      </p>
    </div>
    <div ifSettingTrue="Account_Subscription_Enabled" class="manage-link desktop-view">
      <a
        href="{{ resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value }}"
        target="_blank"
        [gtmClick]="getViewLabel('Account_Subscription_Manage_Link_Text')"
        [gtmLinkURL]="resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value">
        <adp-label labelKey="Account_Subscription_Manage_Link_Text"></adp-label>
        <mat-icon [svgIcon]="'new-page'" class="open-icon"></mat-icon>
      </a>
    </div>

    <div ifSettingTrue="Account_Subscription_Enabled" class="mt-10 manage-link-mobile mobile-view">
      <a
        href="{{ resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value }}"
        target="_blank"
        [gtmClick]="getViewLabel('Account_Subscription_Manage_Link_Text')"
        [gtmLinkURL]="resourceService.getPortalSetting('URL_Account_Subscription_Mangement')?.Value">
        <div>
          <adp-label labelKey="Account_Subscription_Manage_Link_Text" style="float: left; margin-top: 5px"></adp-label>
          <mat-icon [svgIcon]="'new-page'" class="open-icon" style="float: right"></mat-icon>
        </div>
      </a>
    </div>
  </div>
  <div class="mt-20 mb-20 max-width-82">
    <div class="mt-20 pb-4 header-desc">
      <adp-label labelKey="Account_Profile_Message_Text"></adp-label>
    </div>
  </div>
</div>

<div class="container mt-15 mb-100" *ngIf="member">
  <div class="member-avatar">
    <pgh-avatar
      *ngIf="this.selMember$ | async"
      name="{{ this.user.name }}"
      [color]="this.member.profileColor"
      size="75"></pgh-avatar>
    <div class="change-avatar-container">
      <a
        href="javascript:void(0);"
        class="change-member-avatar"
        *ngIf="canChangeAvatar"
        (click)="openEditAvatarModal()"
        [gtmClick]="getViewLabel('Account_Profile_ChangeColorButton_Text')">
        <adp-label labelKey="Account_Profile_ChangeColorButton_Text"></adp-label>
      </a>
    </div>
  </div>
  <div class="profile-info">
    <table class="profile-info-table">
      <tr>
        <td class="profile-info-key">
          <adp-label labelKey="Account_Profile_Username_Label"></adp-label>
        </td>
        <td class="profile-info-value cls_mask">{{ this.user.name }}</td>
      </tr>
      <tr>
        <td class="profile-info-key">
          <adp-label labelKey="Account_Profile_EmailAddress_Label"></adp-label>
        </td>
        <td class="profile-info-value cls_mask">{{ this.user.email }}</td>
      </tr>
      <tr *ngIf="this.member.phoneNumber">
        <td class="profile-info-key">
          <adp-label labelKey="Account_Profile_PhoneNumber_Label"></adp-label>
        </td>
        <td class="profile-info-value cls_mask">{{ maskPhone(this.member.phoneNumber) }}</td>
      </tr>
    </table>
  </div>
</div>
